export default {
  "settingsTargetSaved": "Cible enregistrée",
  "settingsVisual0": "Configurer les missions, les buts, les tâches et les séquences pour chaque étape sauvegardée.",
  "settingsVisual1": "Définir vos étapes, vos couleurs et vos résultats.",
  "settingsVisual2": "Nommer chaque étape et choisir sa couleur et son résultat.",
  "settingsVisual3": "Couleur",
  "settingsVisual4": "Couleur personnalisée",
  "settingsVisual5": "étapes",
  "settingsVisual6": "Entrez les noms d'étape pour voir l'aperçu de votre pipeline.",
  "settingsVisual7": "Tous les changements enregistrés",
  "settingsVisual8": "Organisez votre processus de vente en étapes claires.",
  "settingsVisual9": "Définir un objectif mesurable pour votre équipe.",
  "settingsVisual10": "Gardez vos changements ?",
  "settingsVisual11": "Toutes les tâches de l'équipe, y compris le travail non affecté.",
  "settingsVisual12": "Seules les tâches qui se sont assignées.",
  "settingsVisual13": "Gestionnaires : toutes les tâches d'équipe. Salespersons: ses propres tâches seulement. Les tâches non assignées : les gestionnaires seulement.",
  "settingsVisual14": "Défauts d'accès et d'affectation",
  "settingsVisual15": "Les tâches non assignées ne sont visibles qu'aux gestionnaires.",
  "settingsVisual16": "Définir les défauts d'assignation et examiner l'accès par le rôle de CRM.",
  "settingsVisual17": "Aperçu de l ' envoi",
  "settingsVisual18": "Les règles illustratives seulement — pas le travail en direct.",
  "settingsVisual19": "Éligible task Creator",
  "settingsVisual20": "Propriétaire admissible du prospect",
  "settingsVisual21": "Créateur n'est pas admissible",
  "settingsVisual22": "Le propriétaire principal n'est pas admissible",
  "settingsVisual23": "Membre du personnel",
  "settingsVisual24": "L'accès aux tâches reste le même.",
  "settingsVisual25": "Il aura accès à toutes les tâches de l'équipe.",
  "settingsVisual26": "Ne verront que leurs propres tâches assignées.",
  "settingsVisual27": "Membres du personnel sélectionnés : {count}",
  "settingsVisual28": "Personnel actif",
  "settingsVisual29": "Sélection",
  "settingsVisual30": "Département · Titre de l'emploi",
  "settingsVisual31": "Déjà en équipe de vente",
  "settingsVisual32": "Supprimer la sélection",
  "settingsVisual33": "Choisissez votre équipe",
  "settingsVisual34": "Sélectionnez le personnel à gauche pour examiner leurs rôles ici.",
  "settingsVisual35": "L'accès au CRM sera supprimé",
  "settingsVisual36": "La propriété principale est séparée de l'affectation des tâches.",
  "settingsVisual37": "Travaux de réaffectation",
  "settingsVisual38": "Pas de travail ouvert à la réaffectation",
  "settingsVisual39": "L'histoire achevée reste avec ce fonctionnaire. Seul le travail ouvert peut être transféré.",
  "settingsVisual40": "Transfert de la propriété",
  "settingsVisual41": "Fonctions ouvertes",
  "settingsVisual42": "Conducteurs actifs",
  "settingsVisual43": "Pas de travail ouvert pour le transfert dans cette section.",
  "settingsVisual44": "Prêt à supprimer l'adhésion. L'histoire est préservée.",
  "settingsVisual45": "Choisissez des destinations pour tous les travaux ouverts à poursuivre.",
  "settingsVisual46": "Ajouter du personnel à l'équipe de vente",
  "settingsVisual47": "Choisissez les membres du personnel existants et assignez leur rôle de CRM.",
  "settingsVisual48": "Examiner l'accès et le transfert des travaux ouverts avant de supprimer l'adhésion.",
  "settingsVisual49": "Transférer des tâches ouvertes et des pistes actives tout en préservant l'histoire achevée.",
  "selectALeadToSeeAIInsightsAndSuggestions": "Sélectionnez une piste pour voir des idées et des suggestions d'IA",
  "aIInsights": "Analyses IA",
  "suggestedActions": "Actions suggérées :",
  "confidence": "Confiance :",
  "noActiveInsightsForThisLead": "Pas d'idées actives pour cette avance",
  "suggestedNextSteps": "Prochaines étapes suggérées",
  "timeline": "Chronologie:",
  "aIEmailAssistant": "Assistant e-mail IA",
  "tone": "Ton:",
  "professional": "Administrateurs",
  "friendly": "Amicalement",
  "formal": "Formels",
  "casual": "Occasionnels",
  "generatedDraft": "Projet généré:",
  "sendEmail": "Envoyer par courriel",
  "copyToClipboard": "Copie à Clipboard",
  "briefSummaryOfLeadSJourneyAndStatus": "Bref résumé du parcours et du statut du chef de file",
  "mainTopicsDiscussedSoFar": "Principaux sujets abordés jusqu ' à présent",
  "questionsToAskInNextInteraction": "Questions à poser dans la prochaine interaction",
  "recommendedNextStep": "Recommandation suivante",
  "thingsToWatchOutForOrLeverage": "Les choses à surveiller ou à tirer",
  "aIContactAssistant": "Assistant de contacts IA",
  "analyzing": "Analyser...",
  "insights": "Prise de conscience",
  "lastUpdated": "Dernière mise à jour:",
  "clickGenerateInsightsToGetAIPoweredLeadAnalysis": "Cliquez sur \"Generate Insights\" pour obtenir l'analyse de prospect alimenté par AI",
  "analyzingLeadDataAndGeneratingInsights": "Analyser les données de prospect et générer des idées...",
  "leadSummary": "Résumé du prospect",
  "keyDiscussionTopics": "Thèmes de discussion clés",
  "suggestedQuestions": "Questions suggérées",
  "q": "Q",
  "recommendedNextAction": "Recommandation suivante",
  "importantNotes": "Notes importantes",
  "failedToLoadLeads": "N ' a pas réussi à charger des pistes",
  "leadsUpdated": "Projets mis à jour",
  "failedToAddLeadsToPipeline": "N'a pas ajouté de pistes de pipeline",
  "allLeads": "Tous les chefs",
  "searchFilterAndManageLeadsAcrossAllPipelines": "Effectuez des recherches, filtrez et gérez des pistes dans tous les pipelines.",
  "searchLeadsByNameOrEmail": "Rechercher des prospects par nom ou email",
  "allPipelines": "Tous les pipelines",
  "noPipelineAssigned": "Aucun pipeline n ' est affecté",
  "lead": "Prospect",
  "phone": "Téléphone",
  "source": "Source",
  "pipeline": "Pipeline commercial",
  "stage": "Étape",
  "statusTemp": "Statut / Temp",
  "lastActivity": "Dernière activité",
  "created": "Créé",
  "noLeadsFound": "Aucune piste n'est trouvée.",
  "page": "Page",
  "of": "des",
  "previous": "Précédent",
  "next": "Suivant",
  "leadSSelected": "Le(s) prospect(s) sélectionné(s)",
  "clearSelection": "Sélection claire",
  "addToPipeline": "Ajouter à Pipeline",
  "selectAPipelineToMoveTheSelectedLeadsIntoTheFirstStage": "Sélectionnez un pipeline pour déplacer les pistes sélectionnées dans la première étape.",
  "chooseAPipeline": "Choisissez un pipeline",
  "cancel": "Annuler",
  "confirm": "Confirmer",
  "cRMAnalytics": "Analyses CRM",
  "last7Days": "7 derniers jours",
  "last30Days": "30 derniers jours",
  "last90Days": "90 derniers jours",
  "pipelineValue": "Valeur du pipeline",
  "activeDeals": "Marchés actifs",
  "winRate": "Taux de réussite",
  "avgDealSize": "Avg. Taille des affaires",
  "activeLeads": "Perles actives",
  "conversionRate": "Taux de conversion",
  "target": "Cible",
  "failedToLoadCRMSummary": "N'a pas chargé le sommaire du crm.",
  "pipelineDistribution": "Distribution des pipelines",
  "activityTrends": "Tendances des activités",
  "leadSourcePerformance": "Résultats des sources de prospect",
  "dealHealthOverview": "Aperçu général de la santé",
  "healthyActive": "Santé (actif)",
  "stale14Weeks": "Justification (1 à 4 semaines)",
  "atRisk30Days": "Risque (30 jours et plus)",
  "dealsNeedImmediateAttention": "les offres ont besoin d'attention immédiate",
  "pipelineVelocityAvgDaysInStage": "Velocité des pipelines (Jours en scène)",
  "avgDays": "Aveugle.",
  "status": "Statut",
  "selectAPipelineToViewLeads": "Sélectionnez un pipeline pour afficher les pistes.",
  "failedToLoadLeadList": "N'a pas chargé la liste de prospect.",
  "loadingLeads": "Chargement des pistes...",
  "name": "Nom",
  "company": "Société",
  "contact": "Contact",
  "priority": "Priorité",
  "value": "Valeur",
  "assignedTo": "Affecté à",
  "actions": "Actions",
  "noLeadsFoundForThisPipeline": "Aucune piste n'a été trouvée pour ce pipeline.",
  "loadingPipeline": "Chargement du pipeline...",
  "unableToDetermineClubContext": "Incapable de déterminer le contexte du club.",
  "noCRMPipelinesConfiguredYet": "Aucun pipeline CRM n'a encore été configuré.",
  "selectAPipelineToViewStages": "Sélectionnez un pipeline pour voir les étapes.",
  "failedToLoadPipelineData": "N'a pas chargé les données des pipelines.",
  "followUp": "Suivi :",
  "email": "E-mail",
  "sMS": "SMS",
  "call": "Appeler",
  "noLeadsInThisStage": "Pas de pistes sur cette scène",
  "selectSalesTeamMember": "Sélectionnez un membre de l'équipe de vente",
  "stageGoalsCanTBeSetOnTheFinalNonTerminalStage": "Les objectifs d’étape ne peuvent pas être fixés sur la phase finale non-terminale.",
  "taskType": "Type de tâche",
  "taskName": "Nom de la tâche",
  "taskNote": "Note de synthèse",
  "selectActiveSequence": "Sélectionnez la séquence active",
  "remove": "Retirer",
  "save": "Enregistrer",
  "userAssignments": "Affectations de l ' utilisateur",
  "stageGoals": "Objectifs de la phase",
  "tasks": "Tâches",
  "sequences": "Séquences",
  "editPipeline": "Modifier Pipeline",
  "pipelineName": "Nom du pipeline",
  "loadingStages": "Chargement des étapes...",
  "addStage": "Ajouter la scène",
  "deletePipeline": "Supprimer le pipeline",
  "pipelines": "Pipelines commerciaux",
  "loadingPipelines": "Chargement des pipelines...",
  "stages": "Etapes",
  "sortOrder": "Ordre de tri",
  "edit": "Modifier",
  "createPipeline": "Créer Pipeline",
  "loadingTarget": "Cible de chargement...",
  "label": "Étiquette",
  "annualMemberSignUps": "Inscriptions annuelles des membres",
  "goal": "Objectif",
  "period": "Période",
  "annual": "Annuelle",
  "quarterly": "Trimestre",
  "monthly": "mensuel",
  "saveTarget": "Écart cible",
  "saved": "Sauvegardé.",
  "weeklyActivities": "Activités hebdomadaires",
  "updated": "Actualisé :",
  "use": "Utilisation",
  "pleaseEnterAnAIPromptFirst": "S'il vous plaît entrer une alerte AI d'abord",
  "errorGeneratingContent": "Erreur générant du contenu",
  "templateName": "Nom du modèle",
  "templateName2": "Nom de modèle...",
  "type": "Type",
  "sharing": "Partage",
  "private": "Privé",
  "team": "Équipe",
  "organization": "Organisation",
  "subject": "Sujet",
  "emailSubject": "Sujet de courrier électronique...",
  "category": "Catégorie",
  "categoryOptional": "Catégorie (facultatif)...",
  "aIContentAssistant": "Assistant de contenu IA",
  "eGAFriendlyFollowUpAfterADemo": "Par exemple, un suivi amical après une démo...",
  "generate": "Génération",
  "content": "Table des matières",
  "templateContentUseLeadFirstNameForMergeFields": "Contenu du modèle... Utilisez {{lead.firstName}} pour les champs de fusion",
  "insertField": "Champ d ' insertion:",
  "leadFirstName": "premier prénom",
  "leadLastName": "lead.lastName",
  "leadCompany": "prospect. entreprise",
  "senderName": "expéditeur.name",
  "saveTemplate": "Sauvegarder le modèle",
  "failedToLoadTemplates": "Ne pas charger des modèles",
  "errorSavingTemplate": "Erreur template",
  "templateDuplicated": "Template dupliqué",
  "errorDuplicatingTemplate": "Erreur duplicat template",
  "templateArchived": "Template archivé",
  "errorArchivingTemplate": "Modèle d'archivage d'erreur",
  "emailTemplates": "Modèles de courriel",
  "createAndManageReusableTemplates": "Créer et gérer des modèles réutilisables",
  "createTemplate": "Créer un modèle",
  "searchTemplates": "Modèles de recherche...",
  "allTypes": "Tous les types",
  "loadingTemplates": "Charger des modèles...",
  "noTemplatesFound": "Aucun modèle trouvé",
  "createYourFirstTemplate": "Créez votre premier modèle",
  "qualified": "Qualifié",
  "contactMade": "Contact",
  "tourScheduled": "Tour programmé",
  "tourCompleted": "Tour Terminé",
  "proposalSent": "Proposition Sent",
  "negotiating": "Négociation",
  "closedWon": "Fermé Won",
  "closedLost": "Pertes fermées",
  "low": "Faible",
  "medium": "Moyen",
  "high": "Élevé",
  "hot": "Chaud",
  "setPriority": "Ensemble de priorités",
  "setStage": "Installez Stage",
  "overview": "Vue d’ensemble",
  "activities": "Activités (activités)",
  "aIAssistant": "Assistant IA",
  "notesTasks": "Notes et tâches",
  "contactInformation": "Coordonnées",
  "logActivity": "Activité de compte",
  "convertToMember": "Convertir en Membre",
  "convertedToMember": "Converti en Membre",
  "leadDetails": "Détails du prospect",
  "referringMember": "Membre de référence",
  "membershipInterest": "Intérêt d ' admission",
  "timelineDates": "Heure et dates",
  "nextFollowUp": "Prochain suivi",
  "tourDate": "Date de la visite",
  "notes": "Notes",
  "activityTimeline": "Calendrier des activités",
  "noActivitiesRecordedYet": "Aucune activité n ' a encore été enregistrée",
  "addNote": "Ajouter la note",
  "noNotesOrTasksYet": "Pas de notes ou de tâches",
  "advancedFilters": "Filtres avancés",
  "filterLeads": "Filtrer les prospects",
  "clearAll": "Tout effacer",
  "dateAdded": "Date Télécopiée",
  "allStaffMembers": "Tous les fonctionnaires",
  "leadSource": "Source de prospect",
  "allSources": "Toutes les sources",
  "pipelineStage": "Phase d ' installation",
  "allStages": "Toutes les étapes",
  "allPriorities": "Toutes les priorités",
  "pipelineType": "Type de tuyau",
  "allPipelines2": "Toutes les Pipelines",
  "membership": "Adhésion",
  "corporate": "Entreprise",
  "event": "Événement",
  "referral": "Renvoi",
  "estimatedValueRange": "Portée de valeur estimée",
  "min": "Min.",
  "to": "to",
  "max": "Max.",
  "sourceEvent": "Événement source",
  "allEvents": "Tous les événements",
  "applyFilters": "Appliquer les filtres",
  "pleaseSelectACountryCode": "Veuillez sélectionner un code pays.",
  "pleaseEnterAPhoneNumber": "Veuillez entrer un numéro de téléphone.",
  "enterAValidPhoneNumberBetween8And15Digits": "Entrez un numéro de téléphone valide entre 8 et 15 chiffres.",
  "firstName": "Prénom *",
  "lastName": "Nom *",
  "countryCode": "Code de pays",
  "allCountries": "Tous les pays",
  "phoneNumber": "Numéro de téléphone",
  "pipeline2": "Pipeline commercial *",
  "selectPipeline": "Sélectionnez le pipeline",
  "stage2": "Étape *",
  "selectStage": "Sélectionnez l'étape",
  "source2": "Source *",
  "selectSource": "Sélectionnez la source",
  "website": "Site Web",
  "advertising": "Publicité",
  "socialMedia": "Médias sociaux",
  "coldOutreach": "Sensibilisation au froid",
  "other": "Autre",
  "membershipTypeInterest": "Type d ' adhésion",
  "selectType": "Sélectionnez le type",
  "selectPriority": "Sélectionnez la priorité",
  "leadValue": "Valeur du prospect",
  "unassigned": "Non attribué",
  "interests": "Intérêts",
  "addInterestGolfTennisDiningEtc": "Ajouter l'intérêt (golf, tennis, repas, etc.)",
  "add": "Ajouter",
  "tags": "Étiquettes",
  "addTag": "Ajouter tag",
  "connections": "Connexions",
  "saveLeadFirstToAddConnections": "Enregistrer le prospect avant d'ajouter des connexions.",
  "connectionType": "Type de connexion",
  "member": "Membre",
  "search": "Rechercher",
  "select": "Sélectionner",
  "note": "Note",
  "describeTheRelationship": "Décrivez la relation",
  "addConnection": "Ajouter une connexion",
  "noConnections": "Pas de connexion",
  "leadSourceAnalytics": "Analyse des sources de prospect",
  "refreshData": "Actualiser les données",
  "totalSources": "Sources totales",
  "bestConversion": "Meilleure conversion",
  "topSource": "Source",
  "sourcePerformance": "Performance de source",
  "conversionRatesBySource": "Taux de conversion par source",
  "leadGenerationTrendsLast30Days": "Tendances de la génération de prospect (dernières 30 jours)",
  "detailedSourcePerformance": "Rendement détaillé des sources",
  "totalLeads": "Total des chefs de file",
  "avgValue": "Valeur",
  "totalValue": "Valeur totale",
  "performance": "Rendement",
  "interest": "Intérêts",
  "interestedIn": "Intéressé par:",
  "projectedValue": "Valeur projetée :",
  "leadToMember": "Responsable de l ' adhésion",
  "aNewMemberJoinsTheClub": "Un nouveau membre rejoint le Club",
  "hasReachedClosedWonWouldYouLikeToOfficiallyCreateTheirMemberProfile": "a atteint Fermé Won. Voulez-vous créer officiellement leur profil membre?",
  "keepInClosedWon": "Gardez à l'eau fermée",
  "followUp2": "Suivi",
  "noFollowUp": "Pas de suivi",
  "noActiveLeadsFound": "Aucune piste active n'a été trouvée",
  "logActivityFor": "Activité de journal pour",
  "activityType": "Type d ' activité",
  "meeting": "Réunion",
  "tour": "Visite",
  "outcome": "Résultat",
  "selectOutcome": "Sélectionnez le résultat",
  "positive": "Positif",
  "neutral": "Neutre",
  "negative": "Négatif",
  "noResponse": "Pas de réponse",
  "titleSubject": "Titre / Objet",
  "description": "Description",
  "sent": "Envoyé",
  "openRate": "Taux ouvert",
  "clickRate": "Cliquez sur le taux",
  "bounced": "Rebondi",
  "scheduled": "Prévu :",
  "created2": "Création :",
  "recipients": "Bénéficiaires :",
  "audience": "Public",
  "schedule": "Planning",
  "campaignTitle": "Campagne titre",
  "internalCampaignName": "Nom de la campagne interne",
  "campaignType": "Type de campagne",
  "broadcast": "Diffusion",
  "dripCampaign": "Campagne Drip",
  "leadNurture": "Nurture de prospect",
  "subjectLine": "Objet",
  "emailSubjectLine": "Courrier électronique",
  "previewText": "Texte de prévisualisation",
  "textShownInEmailPreview": "Texte affiché en avant-première e-mail",
  "fromName": "De Nom",
  "replyToEmail": "Répondre à Email",
  "repliesYourclubCom": "replies@yourclub.com",
  "emailContent": "Contenu du courriel",
  "emailHTMLContent": "Email Contenu HTML...",
  "forPersonalization": "pour la personnalisation",
  "targetAudience": "Audience cible",
  "selectedFiltersWillTarget": "Les filtres sélectionnés cibleront",
  "leads": "pistes",
  "leadStages": "Étapes principales",
  "leadSources": "Sources de prospect",
  "priorityLevel": "Niveau de priorité",
  "sendTimeOptional": "Délai d ' envoi (optionnel)",
  "leaveBlankToSendImmediately": "Laisser blanc pour envoyer immédiatement",
  "loadingCampaigns": "Chargement des campagnes...",
  "marketingCampaigns": "Campagnes de marketing",
  "createAndManageEmailCampaignsForYourLeads": "Créer et gérer des campagnes de courriel pour vos prospects",
  "createCampaign": "Créer une campagne",
  "noCampaignsYet": "Pas encore de campagnes.",
  "createYourFirstEmailCampaignToStartNurturingLeads": "Créez votre première campagne email pour commencer à nourrir des prospects",
  "createFirstCampaign": "Créer une première campagne",
  "campaignAnalytics": "Analytics de campagne -",
  "opened": "Ouvert",
  "clicked": "Cliqués",
  "close": "Fermer",
  "failedToLoadProspects": "N ' ont pas réussi à charger des prospects",
  "addedToCRM": "Ajouté à CRM",
  "failedToAddProspectsToCRM": "N'a pas ajouté de prospects à crm",
  "undoComplete": "Annulation terminée",
  "failedToUndoLastImport": "N'a pas défaire la dernière importation",
  "prospects": "prospects",
  "searchVisitorsAndAddThemToYourCRMPipeline": "Recherchez les visiteurs et ajoutez-les à votre pipeline CRM.",
  "searchProspectsByNameOrEmail": "prospects de recherche par nom ou email",
  "undoLastImport": "Undo dernière importation",
  "addToCRM": "Ajouter à CRM",
  "lastVisit": "Dernière visite",
  "totalVisits": "Total des visites",
  "noProspectsFoundYet": "Aucune perspective n'a encore été trouvée.",
  "salesRep": "Ventes rep",
  "salesManager": "Directeur des ventes",
  "failedToLoadSalesTeam": "N'a pas réussi à charger l'équipe de vente",
  "failedToLoadStaff": "Le personnel n ' a pas été chargé",
  "salesTeamMemberAdded": "Membre de l ' équipe de vente",
  "addFailed": "Non.",
  "updateFailed": "Mise à jour échouée",
  "memberRemoved": "Membre enlevé",
  "removeFailed": "Enlèvement échoué",
  "salesTeam": "Équipe de vente",
  "controlWhoCanBeAssignedCRMTasks": "Contrôle qui peut être assigné des tâches CRM.",
  "addTeamMember": "Ajouter Team Member",
  "teamMembers": "Membres d ' équipe",
  "loadingSalesTeam": "Charger l'équipe de vente...",
  "noSalesTeamMembersYet": "Pas encore de membres de l'équipe de vente.",
  "staff": "Personnel",
  "jobTitle": "Titre du poste",
  "role": "Rôle",
  "searchStaff": "Rechercher le personnel",
  "searchByNameEmailTitle": "Recherche par nom, email, titre",
  "selectAStaffMember": "Sélectionnez un fonctionnaire",
  "selectAStepToEditItsProperties": "Sélectionnez une étape pour modifier ses propriétés",
  "onReplyActionS": "Sur les mesures de réponse",
  "createTask": "Créer une tâche",
  "advanceStage": "Étape préliminaire",
  "title": "Titre",
  "taskTitle": "Titre de la tâche",
  "normal": "Normale",
  "assignee": "Responsable",
  "movesTheLeadToTheNextStageBySortOrder": "Déplace la piste vers la prochaine étape par ordre de tri.",
  "emailTemplate": "Modèle de courriel",
  "selectTemplate": "Sélectionnez le modèle...",
  "templateIsRequiredForSendEmailSteps": "Le modèle est requis pour envoyer des étapes par courriel.",
  "body": "Corps",
  "emailBody": "Corps d'email...",
  "previewTemplate": "Modèle de prévisualisation",
  "stopOnReply": "Arrêter sur Réponse",
  "yes": "Oui",
  "no": "Non",
  "sMSTemplate": "SMS Modèle",
  "selectSMSTemplate": "Sélectionnez le modèle SMS...",
  "320Characters": "/320 caractères",
  "duration": "Durée",
  "1Hour": "1 heure",
  "1Day": "1 jour",
  "2Days": "2 Jours",
  "taskType2": "Type de tâche",
  "taskTitle2": "Titre de la tâche",
  "taskTitle3": "Titre de la tâche...",
  "dueInMinutes": "Dû en quelques minutes",
  "noPropertiesForThisStepType": "Pas de propriétés pour ce type d'étape.",
  "stepProperties": "Propriétés d'étape",
  "wait": "Attends.",
  "followUpCall": "Suivi de l'appel",
  "sendSMS": "Envoyer SMS",
  "pleaseEnterASequenceName": "Veuillez saisir un nom de séquence",
  "sequenceSaved": "Séquence enregistrée",
  "sequenceName": "Nom de séquence...",
  "sequenceSteps": "Étapes de séquence",
  "enrollments": "Inscriptions",
  "conversion": "Conversion",
  "active": "Actif",
  "lastModified": "Dernière modification :",
  "scope": "Portée :",
  "viewAnalytics": "Voir Analytics",
  "errorLoadingSequences": "séquences de chargement d'erreurs",
  "errorDuplicatingSequence": "Dédoublement d'erreur",
  "errorDeletingSequence": "Erreur de suppression de la séquence",
  "errorLoadingSequenceDetails": "Détails de la séquence de chargement d'erreur",
  "sequenceLibrary": "Séquence bibliothèque",
  "createAndManageYourEmailSequences": "Créer et gérer vos séquences e-mail",
  "createSequence": "Créer Sequence",
  "searchSequences": "Rechercher des séquences...",
  "allStatus": "Tous les statuts",
  "archived": "Archivé",
  "scope2": "Champ d ' application",
  "allScope": "Toutes les dispositions",
  "loadingSequences": "Chargement des séquences...",
  "noSequencesFound": "Aucune séquence trouvée",
  "createYourFirstSequence": "Créer votre première séquence",
  "stageChange": "Changement d ' étape",
  "fieldUpdate": "Mise à jour sur le terrain",
  "timeBased": "Temps écoulé",
  "manual": "Manuel",
  "moveStage": "Déplacement de la scène",
  "updateField": "Mise à jour du champ",
  "addTag2": "Ajouter Tag",
  "notifyUser": "Avertissement de l'utilisateur",
  "workflowAutomation": "Automatisation des flux de travail",
  "createAutomatedWorkflowsToStreamlineYourSalesProcess": "Créez des workflows automatisés pour rationaliser votre processus de vente",
  "createWorkflow": "Créer Workflow",
  "deleteWorkflow": "Supprimer Workflow",
  "areYouSureYouWantToDelete": "Êtes-vous sûr que vous voulez supprimer \"",
  "thisActionCannotBeUndone": "Cette action ne peut être annulée.",
  "delete": "Supprimer",
  "trigger": "Gâchette :",
  "actions2": "Mesures à prendre :",
  "executions": "Exécutions:",
  "noWorkflowsYet": "Pas encore de flux de travail",
  "createYourFirstWorkflowToAutomateYourSalesProcess": "Créez votre premier flux de travail pour automatiser votre processus de vente",
  "createFirstWorkflow": "Créer un premier flux de travail",
  "workflowName": "Nom du workflow *",
  "eGNewLeadWelcomeSequence": "e.g., nouvelle séquence d'accueil de prospect",
  "triggerType": "Type de déclencheur *",
  "selectTrigger": "Déclencheur",
  "describeWhatThisWorkflowDoes": "Décrivez ce que ce flux de travail fait",
  "addAction": "Ajouter une action",
  "action": "Action",
  "actionType": "Type de mesure",
  "templateNameOrSubject": "Nom du modèle ou sujet",
  "taskDescription": "Description du travail",
  "taskToCreate": "Tâche de créer",
  "targetStage": "Niveau cible",
  "noActionsAddedYetClickAddActionToGetStarted": "Pas encore d'actions. Cliquez sur \"Ajouter Action\" pour commencer.",
  "activateImmediately": "Activation immédiate",
  "assigneesUnavailable": "Assignes non disponibles",
  "tasksCanStillBeSavedAsUnassigned": "Les tâches peuvent encore être sauvegardées comme Non-attribuées.",
  "leadRequired": "prospect requis",
  "selectALeadBeforeCreatingATask": "Sélectionnez une piste avant de créer une tâche.",
  "dueDateRequired": "Date d ' échéance requise",
  "selectAValidDueDateAndTime": "Sélectionnez une date et une heure d'échéance valides.",
  "taskRescheduled": "Tâche reprogrammée",
  "taskCreated": "Tâche créée",
  "taskSaveFailed": "Tâches échouées",
  "planYourNextFollowUp": "Planifiez votre prochain suivi.",
  "lead2": "prospect *",
  "searchByNameEmailPhone": "Recherche par nom, email, téléphone",
  "noResults": "Pas de résultats.",
  "selectLead": "Sélectionnez le prospect",
  "title2": "Titre *",
  "dueDateTime": "Date d ' échéance *",
  "aM": "AM",
  "pM": "PM",
  "saveTask": "Enregistrer la tâche",
  "taskWorkspace": "Workspace",
  "searchTasksLeads": "Tâches de recherche, pistes",
  "refresh": "Actualiser",
  "newTask": "+ Nouvelle tâche",
  "today": "Aujourd'hui:",
  "overdue": "En retard :",
  "upcoming": "À venir :",
  "completed": "Complété:",
  "allAssignees": "Tous les cessionnaires",
  "loadingTasks": "Chargement des tâches...",
  "noTasksMatchYourFilters": "Aucune tâche ne correspond à vos filtres.",
  "assigned": "Affecté",
  "undoCompletion": "Complétion d ' undo",
  "markComplete": "Marque complète",
  "taskFocus": "Thème",
  "selectATaskToFocusYourNextAction": "Sélectionnez une tâche pour focaliser votre prochaine action.",
  "relatedLead": "Concernant le prospect",
  "reschedule": "Postes pourvus",
  "openLead": "Ouvrez le prospect",
  "allUnassigned": "Tout / Désigné",
  "noPhoneNumber": "Pas de numéro de téléphone",
  "thisLeadDoesNotHaveAPhoneNumberOnFile": "Cette piste n'a pas de numéro de téléphone au dossier.",
  "cRMPermissionsAreUnavailable": "Les autorisations de CRM ne sont pas disponibles.",
  "newLead": "Nouveau chef",
  "pipeline3": "Pipeline commercial :",
  "assignee2": "Responsable :",
  "pipelineView": "Vue sur les pipelines",
  "listView": "Liste de vues",
  "failedToLoadCRMPipelines": "N'a pas chargé de crm pipelines.",
  "loadingPipeline2": "Chargement du pipeline...",
  "loadingInteractions": "Chargement des interactions...",
  "noInteractionsLoggedYet": "Aucune interaction n'est encore connectée.",
  "loggedBy": "Classé par :",
  "active2": "Actif (",
  "noActiveSequences": "Aucune séquence active",
  "startSequence": "Démarrer la séquence",
  "someSequencesArePausedOrFailed": "Certaines séquences sont interrompues ou échouées.",
  "nextRun": "Prochaine course :",
  "failed": "Échoué :",
  "stageGoal": "Objectif de l ' étape",
  "noStageGoalForThisStage": "Aucun but de stade pour cette étape",
  "logInteraction": "Interaction de la logique",
  "interactionType": "Type d ' interaction",
  "selectAType": "Sélectionnez un type",
  "phoneCall": "Appel téléphonique",
  "direction": "Direction",
  "selectDirection": "Sélectionnez la direction",
  "outbound": "Dehors",
  "inbound": "D ' entrée",
  "occurredAt": "Survenue",
  "addAnyRelevantNotes": "Ajouter toutes les notes pertinentes",
  "saveInteraction": "Éviter l ' interaction",
  "meetingNoteUnavailable": "Note de réunion non disponible",
  "thisInteractionIsMissingAMeetingLink": "Cette interaction manque un lien de rencontre.",
  "weCouldNotLoadThisMeetingNoteItMayHaveBeenDeletedOrYouMayNotHaveAccess": "Nous ne pouvions pas charger cette note de réunion. Il peut avoir été supprimé ou vous ne pouvez pas avoir accès.",
  "sequenceStarted": "Sequence a commencé",
  "failedToStartSequence": "N'a pas commencé la séquence",
  "interactionLogged": "Interaction enregistrée",
  "failedToLogInteraction": "N ' a pas réussi à enregistrer l ' interaction",
  "leadStageUpdated": "Étape du prospect mise à jour",
  "failedToUpdateStage": "N ' a pas mis à jour l ' étape",
  "unableToChangePipeline": "Incapable de changer de pipeline",
  "theSelectedPipelineHasNoOpenStagesAvailable": "Le pipeline sélectionné n'a pas d'étapes ouvertes disponibles.",
  "failedToUpdatePipeline": "N'a pas mis à jour le pipeline",
  "loadingLead": "Chargement du prospect...",
  "leadNotFound": "Le prospect n'a pas trouvé.",
  "backToCRM": "Retour à CRM",
  "failedToLoadLead": "Je n'ai pas réussi à charger le prospect.",
  "noLeadDataAvailable": "Aucune donnée de prospect n'est disponible.",
  "tags2": "Étiquettes :",
  "addTagsSeparatedByCommas": "Ajouter des balises séparées par des virgules",
  "startSequence2": "Démarrer Sequence",
  "addTask": "Ajouter la tâche",
  "viewCompletedTasks": "Voir les tâches achevées",
  "noActiveTasksForThisLead": "Pas de tâches actives pour cette piste.",
  "overdue2": "En retard",
  "today2": "Aujourd’hui",
  "interactions": "Interactions",
  "logInteraction2": "+ Interaction Logique",
  "failedToLoadInteractions": "N'a pas réussi à charger les interactions.",
  "leadOverview": "Aperçu du prospect",
  "editLead": "Modifier le prospect",
  "loadingConnections": "Chargement des connexions...",
  "source3": "Source :",
  "email2": "E-mail :",
  "phone2": "Téléphone:",
  "company2": "Compagnie:",
  "leadValue2": "Valeur du prospect:",
  "assignedTo2": "Attribué à :",
  "stage3": "Étape :",
  "membershipInterest2": "Intérêt d'adhésion:",
  "interests2": "Intérêts :",
  "cRMLead": "Prospect CRM",
  "sequence": "Séquence",
  "chooseASequence": "Choisissez une séquence",
  "startTimeOptional": "Temps de démarrage (facultatif)",
  "start": "Commencez",
  "completedTasks": "Tâches achevées",
  "noCompletedTasksForThisLead": "Aucune tâche accomplie pour ce chef de file.",
  "reopen": "Réouverture",
  "moveLeadToThisStage": "Avancez jusqu'à cette étape ?",
  "generatingSuggestions": "Générer des suggestions...",
  "clickRefreshToGetAIPoweredNextSteps": "Cliquez sur rafraîchir pour obtenir AI-powered prochaines étapes",
  "generateDraft": "Projet de Génération",
  "failedToGenerateAISummaryPleaseTryAgain": "Failed to generate AI summary. Veuillez réessayer.",
  "justNow": "Juste maintenant.",
  "selectLeadsToManage": "Sélectionnez les pistes pour gérer",
  "noPipeline": "Pas de pipeline",
  "loading": "Chargement…",
  "calls": "Appels",
  "emails": "Courriels",
  "meetings": "Réunions",
  "wonDeals": "Affaires gagnées",
  "slow": "Lent",
  "fast": "Vite !",
  "converted": "Converti",
  "members": "Membres",
  "nA": "N/A",
  "failedToSaveStageAutomation": "N'a pas réussi à Enregistrer l'automatisation de scène",
  "failedToRemoveStageAutomation": "N'a pas supprimé l'automatisation de scène",
  "failedToSavePipelineStages": "N'a pas réussi à économiser les étapes du pipeline",
  "failedToDeletePipeline": "N'a pas supprimé le pipeline",
  "userAssignment": "Affectation de l ' utilisateur",
  "task": "Tâche",
  "cannotDeleteThisStageBecauseItHasLeadsAssigned": "Ne peut pas supprimer cette étape parce qu'il a des pistes assignées.",
  "closedWonAndClosedLostStagesCannotBeRemoved": "Les étapes fermées Won et fermées perdues ne peuvent pas être supprimées.",
  "closedStagesMustBePositionedAtTheEndOfThePipeline": "Les étapes fermées doivent être placées à la fin du pipeline.",
  "pipelineMustIncludeExactlyOneClosedWonAndOneClosedLostStage": "Le pipeline doit comprendre exactement un Won fermé et une étape perdue fermée.",
  "pleaseProvideNamesForAllOpenStages": "Veuillez fournir des noms pour toutes les étapes ouvertes.",
  "cannotDeleteAPipelineThatHasLeadsPleaseMoveOrRemoveLeadsFirst": "Ne peut pas supprimer un pipeline qui a des pistes. S'il vous plaît déplacer ou supprimer les pistes en premier.",
  "pleaseEnsureThereIsExactlyOneClosedWonAndOneClosedLostStage": "S'il vous plaît assurez-vous qu'il y a exactement un Won fermé et une étape perdue fermée.",
  "allActiveStagesNeedAName": "Toutes les étapes actives ont besoin d'un nom.",
  "areYouSureYouWantToDeleteThisPipeline": "Êtes-vous sûr que vous voulez supprimer ce pipeline?",
  "defineWhoShouldWorkOnTheseLeads": "Définir qui devrait travailler sur ces pistes",
  "automaticallyMoveLeadsToTheNextStageOnceTheseGoalsAreMet": "Déplacement automatique conduit à la prochaine étape une fois que ces objectifs sont atteints",
  "createTasksForYourTeamToComplete": "Créez des tâches pour votre équipe",
  "automaticallySendEmailSequencesToALeadOnceItMovesIntoThisStage": "Envoyez automatiquement des séquences d'e-mail à un prospect une fois qu'il se déplace dans cette étape",
  "terminal": "Terminal",
  "failedToLoadCRMTarget": "Ne pas charger la cible crm",
  "failedToCreatePipeline": "N'a pas créé de pipeline",
  "failedToSaveCRMTarget": "N'a pas réussi à Enregistrer la cible de crm",
  "noPreviewAvailable": "Pas de prévisualisation disponible",
  "pleaseEnterATemplateName": "Veuillez saisir un nom de modèle",
  "editTemplate": "Modifier le modèle",
  "templateUpdated": "Modèle mis à jour",
  "templateCreated": "Modèle créé",
  "areYouSureYouWantToDeleteThisTemplate": "Êtes-vous sûr de vouloir supprimer ce modèle?",
  "notSet": "Non défini",
  "end": "Fin",
  "pleaseSelectASource": "Veuillez sélectionner une source.",
  "pleaseSelectAPipelineAndStage": "Veuillez sélectionner un pipeline et une étape.",
  "missingClubContext": "Le contexte du club manquant.",
  "editLead2": "Modifier le prospect",
  "addNewLead": "Ajouter New Lead",
  "selectAMembershipType": "Sélectionnez un type d'adhésion",
  "searchLeadsByNameEmailPhone": "Rechercher des prospects par nom, email, téléphone",
  "searchMembersByNameEmailPhoneMembership": "Rechercher des membres par nom, email, téléphone, adhésion #",
  "selectAResult": "Sélectionnez un résultat",
  "typeAtLeast2CharactersToSearch": "Tapez au moins 2 caractères à la recherche",
  "unnamed": "Non-nommés",
  "noEmail": "Pas de courriel",
  "noContact": "Pas de contact",
  "unknown": "Inconnu",
  "noNote": "Pas de note.",
  "saving": "Enregistrement…",
  "saveChanges": "Sauvegarder les changements",
  "createLead": "Créer le prospect",
  "noActivity": "Aucune activité",
  "yourLead": "Votre avance",
  "creating": "Créer...",
  "createMember": "Créer un membre",
  "system": "Système",
  "voiceRecognitionIsNotSupportedByYourBrowser": "La reconnaissance vocale n'est pas supportée par votre navigateur.",
  "failedToLogActivityPleaseTryAgain": "Vous ne pouvez pas vous connecter. Veuillez réessayer.",
  "pleaseEnterCampaignTitleAndSubject": "Veuillez saisir le titre de la campagne et le sujet",
  "editCampaign": "Éditer campagne",
  "createEmailCampaign": "Créer une campagne Email",
  "updateCampaign": "Mettre à jour la campagne",
  "errorSavingCampaignPleaseTryAgain": "Une campagne d'épargne d'erreur.",
  "errorDuplicatingCampaignPleaseTryAgain": "Erreur double campagne. S'il vous plaît essayez à nouveau.",
  "errorDeletingCampaignPleaseTryAgain": "Nouvelle campagne de suppression d'erreur.",
  "selectProspectsToAddToCRM": "Sélectionnez les prospects pour ajouter à CRM",
  "unknownStaff": "Personnel inconnu",
  "pleaseTryAgain": "Veuillez réessayer.",
  "inactive": "Inactif",
  "noPreviewAvailable2": "Pas d'aperçu disponible.",
  "step": "Étape",
  "errorSavingSequence": "Séquence d ' erreur",
  "saving2": "Enregistrement…",
  "areYouSureYouWantToArchiveThisSequence": "Êtes-vous sûr de vouloir archiver cette séquence?",
  "analyticsViewComingSoon": "Vue d'analyse bientôt!",
  "pleaseFillInTheRequiredFields": "Veuillez remplir les champs requis",
  "errorSavingWorkflowPleaseTryAgain": "Erreur d'économie de flux de travail. Veuillez réessayer.",
  "paused": "Pause",
  "editWorkflow": "Modifier le flux de travail",
  "createNewWorkflow": "Créer un nouveau flux de travail",
  "updateWorkflow": "Mettre à jour le flux de travail",
  "meetingNotes": "Notes de séance",
  "manualUI": "UI manuel",
  "noDueDate": "Sans échéance",
  "unknownTime": "Heure inconnue",
  "noSubject": "(Aucun sujet)",
  "interaction": "Interaction",
  "failed2": "Échec",
  "anErrorOccurredWhileLoggingTheInteraction": "Une erreur s'est produite lors de l'enregistrement de l'interaction.",
  "failedToLoadTasks": "N ' a pas été chargé des tâches",
  "updatingLeadPipeline": "Mise à jour du pipeline de prospect",
  "noNotesYet": "Pas encore de notes.",
  "upcoming2": "À venir",
  "completed2": "Terminé",
  "all": "Tous",
  "noLeadAssociated": "Aucun prospect associé",
  "noDescription": "Pas de description",
  "unnamedLead": "Prospect sans nom",
  "teamMember": "Membre de l ' équipe",
  "assignedUser": "Utilisation assignée",
  "rescheduleTask": "Rechedule Task",
  "receivedEmail": "Courriel reçu",
  "receivedSMS": "Reçue SMS",
  "receivedEmailOrSMS": "E-mail reçu ou SMS",
  "taskCompleted": "Tâche terminée",
  "draft": "Brouillon",
  "cancelled": "Annulé",
  "pending": "En attente",
  "scheduled2": "Planifié",
  "skipped": "Ignoré",
  "running": "Courant",
  "readOnly": "Lire seulement",
  "unableToCompleteThisActionPleaseTryAgain": "Incapable de compléter cette action. Veuillez réessayer.",
  "taskMovedToDate": "La tâche est passée à {date} .",
  "scheduledForDate": "Prévu pour {date} .",
  "movedCountLeadSToPipeline": "Déplacement de {count} prospect(s) à {pipeline}",
  "addedCountProspectSToCRM": "Ajout de {count} prospect(s) à CRM",
  "revertedCountLeadSBackToProspects": "Reversé {count} prospect(s) retour aux prospects",
  "sendEmailStepStepRequiresAnEmailTemplate": "Envoyer E-mail étape {step} nécessite un modèle de courriel",
  "deleteName": "Supprimer {name} ?",
  "editName": "Modifier {name}",
  "duplicateName": "Duplicata {name}",
  "archiveName": "Archives {name}",
  "selectName": "Sélectionnez {name}",
  "moveName": "Déplacement {name}",
  "firstName2": "Prénom",
  "lastName2": "Nom",
  "senderName2": "Nom de l'expéditeur",
  "companyName": "Nom de la société",
  "notAuthorised": "Non autorisé",
  "youDoNotHavePermissionToPerformThisAction": "Vous n'avez pas la permission d'exécuter cette action.",
  "pause": "Pause",
  "resume": "Consommation",
  "dragCancelled": "Drag a annulé.",
  "liftedItemAtPositionPositionUseArrowKeysToMoveSpaceToDropOrEscapeToCancel": "Point levé à la position {position} . Utilisez les touches fléchées pour se déplacer, Espace pour déposer, ou Escape pour annuler.",
  "movingToPositionPosition": "Déménagement à la position {position} .",
  "droppedAtPositionPosition": "Arrêté à la position {position}.",
  "pressSpaceToPickUpAnItemUseArrowKeysToMoveItSpaceToDropOrEscapeToCancel": "Appuyez sur l'espace pour ramasser un élément. Utilisez les touches fléchées pour le déplacer, l'espace pour déposer, ou Escape pour annuler.",
  "startDate": "Date de début",
  "duplicate": "Duplicata",
  "archive": "Archiver",
  "selectAll": "Sélectionnez",
  "selectProspect": "Sélectionner la perspective",
  "noDataAvailable": "Aucune donnée disponible",
  "errorGeneratingEmailDraftPleaseTryAgain": "Erreur générant l'ébauche de courriel. Veuillez réessayer.",
  "open": "Ouvrir",
  "countHoursAgo": "Il y a (en heures) : {count}",
  "countDaysAgo": "Il y a (en jours) : {count}",
  "generateInsights": "Générer des idées",
  "thisLeadHasAlreadyBeenConverted": "Cette avance a déjà été convertie.",
  "aMemberWithTheseContactDetailsAlreadyExists": "Un membre avec ces coordonnées existe déjà.",
  "selectAStageInTheSelectedPipeline": "Sélectionnez une étape dans le pipeline sélectionné.",
  "chooseAnActiveSalesTeamMember": "Choisissez un membre actif de l'équipe de vente.",
  "thereIsNoImportToUndo": "Il n'y a pas d'importation à défaire.",
  "taskTypeAndNameAreRequired": "Le type de tâche et le nom sont requis.",
  "sequenceHasNoStepsAddStepsBeforeEnrollingLeads": "Séquence n'a pas d'étapes. Ajouter les étapes avant l'inscription des pistes.",
  "sequenceIsArchivedActivateItBeforeEnrollingLeads": "Sequence est archivée. Activez-le avant d'inscrire des prospects.",
  "theSequenceMustBeActiveBeforeEnrollingLeads": "La séquence doit être active avant l'inscription des pistes.",
  "sequenceNotFound": "Sequence non trouvée.",
  "pipelineNotFound": "Pipeline non trouvée.",
  "taskNotFound": "Tâche non trouvée.",
  "checkTheRequiredFieldsAndTryAgain": "Vérifiez les champs requis et essayez à nouveau.",
  "selectAValidStage": "Sélectionnez une étape valide.",
  "enterAnAIPrompt": "Entrez un appel d'IA.",
  "chooseEmailOrSMS": "Choisissez Email ou SMS .",
  "golfVisitorLog": "Journal de visiteurs de golf",
  "racquetVisitorLog": "Registre des visiteurs racquet",
  "spaVisitorLog": "Spa visiteur journal",
  "fitnessVisitorLog": "Journal de visiteur de fitness",
  "diningVisitorLog": "Journal de visite de Dining",
  "visitorLog": "Journal des visiteurs",
  "settingsLeads": "prospects",
  "settingsRedesign0": "Paramètres de CRM",
  "settingsRedesign1": "Gérez votre équipe de vente, vos pipelines et vos cibles.",
  "settingsRedesign2": "Équipe de vente",
  "settingsRedesign3": "Ajouter le personnel existant et leur donner un rôle CRM. Cela ne change pas leur titre d'emploi ou d'accès au club.",
  "settingsRedesign4": "Ajouter le personnel",
  "settingsRedesign5": "Recherche par nom du personnel",
  "settingsRedesign6": "Filtre à rôle",
  "settingsRedesign7": "Tous rôles",
  "settingsRedesign8": "Directeurs de vente",
  "settingsRedesign9": "Vendeurs",
  "settingsRedesign10": "Salespersonne",
  "settingsRedesign12": "Toutes les tâches du club CRM",
  "settingsRedesign13": "Seules les tâches assignées",
  "settingsRedesign14": "Rôle CRM",
  "settingsRedesign15": "résultats",
  "settingsRedesign16": "Filtres transparents",
  "settingsRedesign17": "Réessayer",
  "settingsRedesign18": "Pas de personnel assorti.",
  "settingsRedesign19": "Rôle inconnu",
  "settingsRedesign20": "Changement de rôle CRM",
  "settingsRedesign21": "Cette personne aura accès à toutes les tâches du club CRM.",
  "settingsRedesign22": "Cette personne ne pourra voir que leurs tâches assignées.",
  "settingsRedesign23": "Appliquer le rôle",
  "settingsRedesign24": "Mesures prises par le personnel",
  "settingsRedesign25": "Réaffectation des travaux",
  "settingsRedesign26": "Supprimer de l ' équipe de vente",
  "settingsRedesign27": "Ajouter le personnel sélectionné",
  "settingsRedesign28": "Réaffectation et suppression",
  "settingsRedesign29": "Personnel de recherche",
  "settingsRedesign30": "Nom de recherche, département ou titre d'emploi",
  "settingsRedesign31": "fonctionnaires sélectionnés",
  "settingsRedesign32": "Déjà ajouté",
  "settingsRedesign33": "Identité authentique existante requise",
  "settingsRedesign34": "Chargement du personnel...",
  "settingsRedesign35": "tâches ouvertes",
  "settingsRedesign36": "pistes actives",
  "settingsRedesign37": "Chargement du travail...",
  "settingsRedesign38": "Leur dossier personnel et leur historique de travail terminé restent. Le travail ouvert doit être transféré avant l'enlèvement.",
  "settingsRedesign39": "Rechercher le personnel de destination",
  "settingsRedesign40": "Nouveau cessionnaire",
  "settingsRedesign41": "Nouveau propriétaire principal",
  "settingsRedesign42": "Sélectionnez la destination",
  "settingsRedesign43": "Inclure la propriété active du prospect",
  "settingsRedesign44": "Les tâches accomplies et les pistes fermées ne seront pas modifiées.",
  "settingsRedesign45": "Aperçu de l ' avant-projet",
  "settingsRedesign46": "Sélectionnez le personnel pour continuer.",
  "settingsRedesign47": "Règles de travail",
  "settingsRedesign48": "Les gestionnaires voient toutes les tâches du club CRM. Les vendeurs ne voient que leurs propres. Les tâches non assignées sont visibles pour les gestionnaires.",
  "settingsRedesign49": "Gérer les règles",
  "settingsRedesign50": "Enregistrer les règles",
  "settingsRedesign51": "Visibilité des tâches",
  "settingsRedesign52": "Fixe par rôle",
  "settingsRedesign53": "Défauts d ' affectation",
  "settingsRedesign54": "Propriétaire par défaut de nouvelles tâches",
  "settingsRedesign55": "Créateur de tâches",
  "settingsRedesign56": "prospect owner",
  "settingsRedesign57": "Gestionnaire de secours",
  "settingsRedesign58": "Désaffecté — visible par les gestionnaires",
  "settingsRedesign59": "De nouvelles tâches utilisent le créateur de tâches admissible. Sinon, elles restent non attribuées.",
  "settingsRedesign60": "De nouvelles tâches utilisent le propriétaire principal admissible, puis le gestionnaire de la chute. Sans l'un ni l'autre, elles demeurent non attribuées.",
  "settingsRedesign61": "Les défauts ne s'appliquent qu'aux nouvelles tâches. Les cessions existantes et les cessionnaires explicitement autorisés sont conservés. Les vendeurs ne peuvent créer que des tâches pour eux-mêmes.",
  "settingsRedesign62": "Enregistrer les modifications",
  "settingsRedesign64": "Changements non enregistrés",
  "settingsRedesign65": "Gardez vos changements avant de fermer ?",
  "settingsRedesign66": "Continuez à éditer",
  "settingsRedesign67": "Changements de carte",
  "settingsRedesign68": "Cibles",
  "settingsRedesign69": "Saisissez un objectif positif de nombre entier.",
  "settingsRedesign70": "L'étiquette est requise.",
  "settingsRedesign71": "Éditer le pipeline",
  "settingsRedesign72": "Créer un pipeline",
  "settingsRedesign73": "Sauvegarder le pipeline",
  "settingsRedesign74": "Ordonnance",
  "settingsRedesign75": "Fournir des noms d'étape uniques, un nom de pipeline et un ordre de tri valide.",
  "settingsRedesign76": "Nom de l ' étape",
  "settingsRedesign77": "Couleur de la scène",
  "settingsRedesign78": "Résultat de la phase",
  "settingsRedesign79": "Gagné.",
  "settingsRedesign80": "Perdus",
  "settingsRedesign81": "Avancez !",
  "settingsRedesign82": "Déplacez l'étape vers le bas",
  "settingsRedesign83": "Supprimer le stade",
  "settingsRedesign84": "Les résultats avec les documents existants ne peuvent pas être modifiés. Déplacer les dossiers à une étape avec le même résultat avant de le supprimer.",
  "settingsRedesign85": "les prospects doivent se déplacer avant que cette étape puisse être supprimée.",
  "settingsRedesign86": "Stade de destination",
  "settingsRedesign87": "Gardez l'étape",
  "settingsRedesign88": "Prévisions de pipeline",
  "settingsRedesign89": "Gardez un Won et une étape perdue à la fin. Faites glisser les étapes ou utilisez les boutons fléchés pour réorganiser.",
  "settingsRedesign90": "enregistrés",
  "settingsRedesign93": "Vos changements sont obsolètes. Rafraîchissez l'aperçu et examinez les travaux mis à jour avant de confirmer.",
  "settingsRedesign94": "Ce disque a changé. Fermer et rouvrir l'éditeur avant d'essayer à nouveau.",
  "settingsRedesign95": "Choisissez un gestionnaire de remplacement dans les règles de la tâche d'abord.",
  "settingsRedesign96": "L'admissibilité du personnel a changé. Rafraîchissez le picker du personnel et révisez votre sélection.",
  "settingsRedesign97": "Certains employés sélectionnés sont déjà dans l'équipe de vente. Rafraîchissez et essayez à nouveau.",
  "settingsRedesign98": "Choisissez une destination admissible pour chaque type de travail ouvert.",
  "settingsRedesign99": "Les dossiers existants empêchent de modifier ce résultat. Garder le résultat pour préserver l'information.",
  "settingsRedesign100": "Choisissez une étape de destination dans ce pipeline avec le même résultat.",
  "settingsRedesign101": "Les permissions de CRM ne sont pas disponibles. Veuillez réessayer.",
  "settingsStageAutomations": "Automatisations de scène",
  "settingsUnableToLoadSettings": "Impossible de charger les réglages.",
  "settingsChangesNotSaved": "Changements non enregistrés",
  "settingsAddCountStaff": "Ajouter {count} employés",
  "settingsReplacementFallbackManager": "Gestionnaire de remplacement",
  "settingsStageAssignmentDefaultsWillAlsoTransferToTheNewLeadOwner": "les défauts d'assignation d'étape seront également transférés au nouveau propriétaire principal.",
  "settingsUseAssignmentDefault": "Utiliser la valeur par défaut",
  "settingsNoTaskAccess": "Aucun accès aux tâches",
  "settingsNoEligibleStaffAreAvailable": "Aucun personnel admissible n ' est disponible."
}
